module.exports = function() {
  return new Worker(__webpack_public_path__ + "03edb98b74588a1b48d4.worker.js");
};